__turbopack_context__.v({
  "ant-upload-drag-icon": "video-uploader-module__1woKHW__ant-upload-drag-icon",
  "ant-upload-hint": "video-uploader-module__1woKHW__ant-upload-hint",
  "ant-upload-text": "video-uploader-module__1woKHW__ant-upload-text",
  "dragger": "video-uploader-module__1woKHW__dragger",
  "uploadContent": "video-uploader-module__1woKHW__uploadContent",
  "videoUploader": "video-uploader-module__1woKHW__videoUploader",
});
